import Slider from 'components/3catinfo/Slider';
import Destacat from '../Destacat';
import styles from './firmes.module.scss';

const Firmes = (props) => {
    const { items, titolSlider, routePath, infoBlocRedl } = props;

    return (
        <>
            {items && (
                <div className={styles.firmes}>
                    <Slider titol={titolSlider} format='noticiaAutor' estil='tira_firmes' fletxes='mig' noTitol='true'>
                        {items?.slice(0, 4).map((item, index) => (
                            <Destacat
                                format='noticiaAutor'
                                key={`destacat-autor-${item.id}`}
                                item={item}
                                index={index + 1}
                                routePath={routePath}
                                infoBlocRedl={infoBlocRedl}
                            />
                        ))}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default Firmes;
